import { Component, OnDestroy, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChanges, ViewChild, ViewEncapsulation } from '@angular/core';
import { concat, merge, of, Subscription } from 'rxjs';
import { finalize, map } from 'rxjs/operators';

import { TreeNode } from 'primeng/api';
import { Tree } from 'primeng/tree';
import { FilterService } from 'primeng/api';

import { environment } from 'src/environments/environment';

import { Product, ProductListFetchParams } from 'src/app/shared/product'
import { ProductGroup } from 'src/app/shared/product-group'

import { GlobalSettingsData } from 'src/app/shared/global-settings-data'
import { GetglobalsettingsService } from 'src/app/services/getglobalsettings.service'
import { ProductApiService } from 'src/app/services/product-api.service';
import { DocumentApiService } from 'src/app/services/document-api.service';

/*
 * TODO: Group adding, deleting, renaiming
 *
 * TODO: Drag and drop groups and content
 */

@Component({
  selector: 'app-prod-group-tree',
  templateUrl: './prod-group-tree.component.html',
  styleUrls: ['./prod-group-tree.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class ProdGroupTreeComponent implements OnInit {
  private globalSettinsData: GlobalSettingsData;

  private _groupsQuery: Subscription;
  private _groupQuery: Subscription;
  private _childGroupsQuery: Subscription;

  @Input() groupId: number = 202;
  @Input() showSearch: boolean = true;

  @Input() reloadTree: any[] = null;

  @Input()  closeOnSelection: boolean = false;

  prodNameFilter: string;

  loading: boolean = false;

  groupTree: TreeNode<number>[] = [];
  currentNode: TreeNode<number>;
  selectedGroupNode: TreeNode<number>;

  groups: ProductGroup[];
  topmostProdGroup: ProductGroup;
  childProdGroups: ProductGroup[];
  selectedProdGroup: ProductGroup;

  @Output() public selectedGroup: EventEmitter<ProductGroup> = new EventEmitter();

  @ViewChild('PGTREE1') pgTreeComp: Tree;

  constructor(
    private prodApi: ProductApiService,
    private globalsettingsservice: GetglobalsettingsService,
    private filterService: FilterService
  ) { }

  findNode(node: TreeNode<number>[], group: number, expand: boolean): TreeNode<number> {
    if (node.length > 0) {
      //console.log('*** ProdGroupTreeComponent expandGroup: ===> Entering with ' + group);
      //environment.production || console.table(node);

      for (let e of node) {
        if (<number>e.data == group) return e;
        let n = this.findNode(e.children, group, expand);
        if (n) {
          e.expanded = expand && true;
          return n;
        }
      }
    }
    return null;
  }

  onGroupSelection(event) {
    console.log('*** ProdGroupTreeComponent onGroupSelection  ');
    //environment.production || console.table(event.node);
    //environment.production || console.table(this.selectedGroupNode);

    let pgn: number = (event.node.data);
    this.loadProdGroup(pgn);
    this.selectedGroup.emit(this.groups.find(g => (g.PGROUPID == pgn)));
  }

  loadProdGroup(pgn: number): void {

    if (pgn) {
      environment.production || console.log('*** ProdGroupTreeComponent loadProdGroup: ===> group: ' + pgn);
      this._groupQuery = this.prodApi.getProdGroupById(pgn)
        .pipe(
          map(data => {
            this.selectedProdGroup = data;
            if (this.selectedProdGroup) {

            }
          })
        )
        .subscribe(() => {
          if (this.selectedProdGroup) {
            //console.log('*** ProdGroupTreeComponent loadProdGroup: ===> getSelectedPg 1: ' + JSON.stringify(this.selectedProdGroup));
          }
        });
    }
  }

  expandGroup(pgn: number) {
    //console.log('*** ProdGroupTreeComponent expandGroup: ===> Entering with ' + pgn);
    //environment.production || console.table(this.groupTree);

    let gn: TreeNode<number> = this.findNode(this.groupTree, pgn, true);
    this.selectedGroupNode = gn;
    //console.log('*** ProdGroupTreeComponent expandGroup: ===> expandGroup to: ' + JSON.stringify(gn));
  }

  getNode(gr: ProductGroup): TreeNode<number> {
    this.loading = true;
    //console.log('*** DocumentsTreeComponent reloadDocTree: ===> getNode: ' + JSON.stringify(doc));
    let newNode: TreeNode<number> = {};
    try {
      newNode.label = gr.PGROUPNAME + ' (' + gr.PGROUPID + ')';
      newNode.data = gr.PGROUPID;
      newNode.key = gr.PGROUPID.toString();
      newNode.expanded = false;
      newNode.children = [];

      if (gr.PGROUPID == this.groupId) {
        newNode.expanded = true;
        this.selectedGroupNode = newNode;
        this.selectedProdGroup = gr;
      }

      this.groups.filter(e => ((e.PGROUPID != 0) && (e.PGUPPERID == gr.PGROUPID))).forEach(g => {
        //console.log('*** ProdGroupTreeComponent doLoadGroupList ' + JSON.stringify(g));
        newNode.children.push(this.getNode(g));
      });
    } catch (err) {
      console.log('*** DocumentsTreeComponent reloadDocTree: ===> getNode ERR: ' + JSON.stringify(err));
    }

    return newNode;
  }

  //reloadDocTree() {
  //  if (this.document) {
  //    console.log('*** DocumentsTreeComponent reloadDocTree: ===> document: ' + this.document.DOCID);
  //    this.topDocQuery = this.docApi.getTopDocListEntry(this.document.DOCID)
  //      .pipe(
  //        map(data => this.topmostDoc = data[0])
  //      )
  //      .subscribe(() => {
  //        if (this.topmostDoc) {
  //          console.log('*** DocumentsTreeComponent reloadDocTree: ===> getTopDoc 1: ' + JSON.stringify(this.topmostDoc));

  //          this.docTreeNodes[0] = this.getNode(this.topmostDoc);
  //          this.docTreeNodes[0].expanded = true;

  //          this.loading = false;
  //        }
  //      });
  //  }
  //}

  ngOnChanges(changes: SimpleChanges) {
    for (let propName in changes) {
      let change = changes[propName];
      //console.log('*** ProdGroupTreeComponent ngOnChanges:');

      //console.log('*** ProdGroupTreeComponent ngOnChanges ' + propName + ' (actual): ' + JSON.stringify(change.currentValue));
      //console.log('*** ProdGroupTreeComponent ngOnChanges ' + propName + ' (was):    ' + JSON.stringify(change.previousValue));

      switch (propName) {
        case 'groupId':
          this.expandGroup(change.currentValue);
          break;

        case 'reloadTree':
          if (change.currentValue) {
            environment.production || console.log('*** ProdGroupTreeComponent ngOnChanges ' + propName + ' (actual): ' + JSON.stringify(change.currentValue));
            environment.production || console.log('*** ProdGroupTreeComponent ngOnChanges ' + propName + ' (was):    ' + JSON.stringify(change.previousValue));
            this.doLoadGroupList();
          }
          break;
      }
    }
  }

  ngOnDestroy(): void {
    console.log('*** ProdGroupTreeComponent in ngOnDestroy')

    if (this._groupsQuery) { this._groupsQuery.unsubscribe(); }

    if (this._childGroupsQuery) { this._childGroupsQuery.unsubscribe(); }

    if (this._groupQuery) { this._groupQuery.unsubscribe(); }
  }

  doLoadGroupList() {
    console.log('*** ProdGroupTreeComponent in doLoadGroupList');
    this.loading = true;
    this._groupQuery = this.prodApi.getProdGroups()
      .pipe(

        map(data => {
          this.groupTree = [];

          this.groups = data;
          this.groups
            .filter(e => ((e.PGROUPID != 0) && (e.PGUPPERID == 0)))
            .forEach(g => {
            this.groupTree.push(this.getNode(g));
            });

          this.groupTree = [... this.groupTree];

          this.loading = false;
          this.reloadTree = null;
          this.expandGroup(this.groupId);
        }),

        finalize(() => {
          environment.production || console.log('*** ProdGroupTreeComponent doLoadGroupList finalize: ');
        })
      )
      .subscribe();
  }

  ngOnInit(): void {
    console.log('*** ProdGroupTreeComponent in ngOnInit');

    this.globalSettinsData = this.globalsettingsservice.getGlobalSettings();
    this.doLoadGroupList();
  }
}
